export enum ContractTemplateType {
  Contract = 'contract',
  NDA = 'nda',
  TermSheet = 'termsheet',
  Shared = 'shared',
}
